import React from 'react'

const Title = ({photoData}) => {
  return (
  <div>
    <h1>{photoData}</h1>
  </div>    
  )
}

export default Title